module.exports = __webpack_public_path__ + "img/4890759.png";